import { ACTIONS } from "../../_config";

interface InventoryState {
    stockTakeList: any[];
    returnOrderData: any[] | null;
}

const initialState: InventoryState = {
    stockTakeList: [],
    returnOrderData: null,
};

export default function inventoryReducer(state = initialState, action: any) {
    switch (action.type) {
        case ACTIONS.INVENTORY.STOCK_TAKE_LIST:
            return {
                ...state,
                stockTakeList: action.payload,
            };
        case ACTIONS.INVENTORY.SET_RETURN_ORDER_DATA:
            return {
                ...state,
                returnOrderData: action.payload,
            };
        default:
            return state;
    }
}
